import f from './filter';

export type { Operand } from './filter';
export const CaseMode = f.CaseMode;
export const MatchMode = f.MatchMode;
export const filtrify = f.filtrify;
export const C = f.Compare; // alias
